import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";
import { pickWorkspaceGuia } from "./workspace-guia";

interface WorkspaceGuiaState {
  loading: boolean;
  name: string | null;
}

interface ListedAssistant {
  id: string;
  name: string;
  scope: string;
  organization_id: string | null;
}

export function useWorkspaceGuia(): WorkspaceGuiaState {
  const { activeWorkspaceId } = useAuth();
  const [state, setState] = useState<WorkspaceGuiaState>({ loading: true, name: null });

  useEffect(() => {
    let cancelled = false;
    setState({ loading: true, name: null });
    (async () => {
      const { data, error } = await supabase.rpc("list_my_knowledge_assistants");
      if (cancelled) return;
      const match = error ? null : pickWorkspaceGuia(data as ListedAssistant[] | null, activeWorkspaceId);
      setState({ loading: false, name: match?.name ?? null });
    })();
    return () => {
      cancelled = true;
    };
  }, [activeWorkspaceId]);

  return state;
}
